const config = {
  dateFormat: 'll',
  apiBaseEndPoint: process.env.REACT_APP_API_PROD_HOST || '/api',
};

export default config;
